import React from 'react';
import { Box } from '@mui/material';
import boschDevoto from '../imgs/jpgs/bosch-devoto-logo.webp';

/**
 * FloatingBadge
 * Non-clickable informational badge placed bottom-left (opposite WhatsApp bubble).
 */
export default function FloatingBadge({ label }) {
  return (
    <Box
      id="floating-badge"
      sx={{
        position: 'fixed',
        bottom: 20,
        left: 20,
        width: 88,
        height: 88,
        borderRadius: 2,
        backgroundColor: '#ffffff',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        boxShadow: '0 6px 18px rgba(0,0,0,0.12)',
        zIndex: 2000,
        pointerEvents: 'none',
      }}
      aria-hidden={label ? 'false' : 'true'}
    >
      <img
        src={boschDevoto}
        alt={label || 'Mecamotor'}
        width={72}
        height={72}
        style={{ width: 72, height: 72, objectFit: 'cover', borderRadius: 6 }}
      />
    </Box>
  );
}
